import { ObservableStore } from '@codewithdan/observable-store';
import { filter } from 'rxjs/operators';
import materials from '../../data/materials';
import { MaterialKey, Part, Store } from '../types';
import { Draft } from './Store';

export class Editor extends ObservableStore<Store> {
    stateChanged = this.stateChanged.pipe(filter((state) => !!state));

    constructor() {
        super({});
    }

    get() {
        return this.getState().editor;
    }

    init(editor: Store['editor']) {
        this.setState({ editor }, 'init_editor');
    }

    isSaved(draftSaved?: boolean) {
        if (draftSaved != null)
            this.setState({
                editor: {
                    ...this.getState().editor,
                    draftSaved,
                },
            });
        return this.getState().editor.draftSaved;
    }

    setPartsGlobal(partIds: Part['id'][]) {
        const allParts = this.getState().draft.parts;
        partIds.forEach((partId) => {
            this.setPart(allParts[partId]);
        });
    }

    setPart(part: Store['editor']['part']) {
        const currentSwatch = this.getState().editor.swatch;
        if (
            part.swatch &&
            currentSwatch.material === part.swatch.material &&
            currentSwatch.index === part.swatch.index
        ) {
            return;
        }

        Draft.changePartSwatch(part, currentSwatch);
        this.setState(
            ({ editor }) => ({
                editor: {
                    ...editor,
                    part,
                    draftSaved: false,
                },
            }),
            'set_part'
        );
    }

    setSwatch(swatch: Store['editor']['swatch']) {
        this.setState(
            ({ editor }) => ({
                editor: {
                    ...editor,
                    swatch,
                },
            }),
            'set_swatch'
        );
    }

    toggleShadow() {
        this.setState(
            ({ editor }) => ({
                editor: {
                    ...editor,
                    shadow: !editor.shadow,
                },
            }),
            'toggle_shadow'
        );
    }

    selectMaterial(material: MaterialKey) {
        this.setState(
            ({ editor }) => ({
                editor: {
                    ...editor,
                    material,
                    swatch: materials[material].swatches[0],
                },
            }),
            'set_material'
        );
    }
}

export default new Editor();
